// core/WidgetCloseControl.ts
/**
 * Type Guard для проверки: реализует ли объект WidgetCloseControl.
 *
 * Используется в PageCloseController, чтобы безопасно вызывать canClose()
 * только у тех виджетов, которые реально поддерживают этот интерфейс.
 */
function isWidgetCloseControl(x) {
    return !!x && typeof x.canClose === 'function';
}

export { isWidgetCloseControl };
